import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
      nav("/admin/dashboard");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5ebd6] p-4">
      <form onSubmit={submit} className="bg-white shadow-xl rounded-md p-8 w-full max-w-md">
        <h1 className="font-serif-display text-3xl text-[#2a2a2a] text-center">Admin Login</h1>
        <p className="text-sm text-gray-500 text-center mb-6">The Benne Corner CMS</p>

        {err && <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-2 rounded mb-3">{err}</div>}

        <label className="block text-xs font-medium text-gray-600 mb-1">Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:border-[#a08862]"
          required
        />
        <label className="block text-xs font-medium text-gray-600 mb-1">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-6 focus:outline-none focus:border-[#a08862]"
          required
        />
        <button
          disabled={loading}
          className="w-full bg-[#a08862] hover:bg-[#8e7654] text-white py-3 rounded transition-colors flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Sign In
        </button>
        <p className="text-xs text-gray-400 text-center mt-4">
          Default: <code>admin / admin123</code>
        </p>
      </form>
    </div>
  );
}
